var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      [
        _c(
          "div",
          { staticClass: "flex flex-row gap-2 pt-4 flex-wrap" },
          [
            _c("FormGroup", {
              attrs: {
                type: "search",
                title: "",
                iconStyle: "customIcon",
                inputClass: "customFormInput",
                placeholder: "Enter group name",
                debounceTime: 500,
              },
              model: {
                value: _vm.title,
                callback: function ($$v) {
                  _vm.title = $$v
                },
                expression: "title",
              },
            }),
            _c(
              "FormGroup",
              [
                _c("ContractorsMultiselect", {
                  attrs: {
                    max: 5,
                    placeholder: "Resources",
                    getParentcontainerStyle: "smallHeight customWidthInput",
                    contractorsConditions: _vm.contractorsWhere,
                  },
                  model: {
                    value: _vm.contractorsIds,
                    callback: function ($$v) {
                      _vm.contractorsIds = $$v
                    },
                    expression: "contractorsIds",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              [
                _c("GroupLocationsMultiselect", {
                  attrs: { getcontainerStyle: "smallHeight" },
                  model: {
                    value: _vm.locations,
                    callback: function ($$v) {
                      _vm.locations = $$v
                    },
                    expression: "locations",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              [
                _c("PostingsMultiselect", {
                  attrs: {
                    placeholder: "Posting",
                    getcontainerStyle: "smallHeight",
                    postingsConditions: _vm.postingsWhere,
                  },
                  model: {
                    value: _vm.postings,
                    callback: function ($$v) {
                      _vm.postings = $$v
                    },
                    expression: "postings",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              [
                _c("SkillsMultiselect", {
                  attrs: { getcontainerStyle: "smallHeight" },
                  model: {
                    value: _vm.skillsIds,
                    callback: function ($$v) {
                      _vm.skillsIds = $$v
                    },
                    expression: "skillsIds",
                  },
                }),
              ],
              1
            ),
            _c("UiButtonMessage", {
              attrs: {
                buttonClass: "customAdd",
                buttonText: "Reset",
                textClass: "customText customOnlyText",
              },
              on: { click: _vm.handleReset },
            }),
          ],
          1
        ),
      ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }